import { UBAlertModal, UBButton } from "../../../Libraries";
import LineText from "../../../Libraries/LineText";
import { useRef, useState } from "react";
import VariantInput from "./VariantInput";
import {
  VariantTextPlaceholders,
  ATTR_OPTION_ACTIONS,
  checkDraginLimit,
  filterOptArray,
  mapTextOptArray,
} from "../../../constants/variantConstants";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import ConfirmationModal from "../Modals/ConfirmationModal";

const VariantTextComponent = ({
  keyId = "Size",
  attributes = [],
  handleSave,
  stock,
  closeEdit,
  isFromEditFlow,
}) => {

  const [showDiscard, setShowDiscard] = useState(false);
  const [showErr, setShowErr] = useState(false);
  const [currentInputs, setCurrentInputs] = useState(
    attributes?.length
      ? [...attributes, { label: "", value: "" }]
      : [{ label: "", value: "" }]
  );

  const dragOverRef = useRef(null);
  const dragStartRef = useRef([]);


  const handleCancel = (st) => {
    setShowDiscard(false);
  };

  const handleSaveDiscard = (st) => {
    if (stock && stock?.variants?.length) {
      setShowDiscard(false);
      closeEdit && closeEdit();
      return;
    }
    setCurrentInputs([{ label: "", value: "" }]);
    handleSave && handleSave("", []);
    setShowDiscard(false);
  };

  const handleSwap = () => {
    if (
      dragOverRef.current == null ||
      dragStartRef.current == null ||
      dragOverRef.current === dragStartRef.current ||
      dragOverRef.current + 1 === currentInputs.length
    ) {
      dragOverRef.current = null;
      dragStartRef.current = null;
      return;
    } else {
      let tempClone = [...currentInputs];
      [tempClone[dragOverRef.current], tempClone[dragStartRef.current]] = [
        tempClone[dragStartRef.current],
        tempClone[dragOverRef.current],
      ];
      setCurrentInputs(tempClone);
      dragOverRef.current = null;
      dragStartRef.current = null;
    }
  };

  const handleAttrOptionChange = (action = "", val = "", ind = 0) => {
    const curr = [...currentInputs];
    if (val === "" && currentInputs.length >= 2) {
      curr.splice(ind, 1);
      setCurrentInputs(curr);
      return;
    }
    if (action === ATTR_OPTION_ACTIONS.INPUT) {
      curr[ind].value = val;
      curr[ind].label = null;
      if (ind + 1 === currentInputs.length) {
        curr.push({ label: "", value: "" });
      }
      setCurrentInputs(curr);
    } else if (action === ATTR_OPTION_ACTIONS.DELETE) {
      if (1 !== currentInputs.length && ind + 1 !== currentInputs?.length) {
        curr.splice(ind, 1);
        setCurrentInputs(curr);
      }
    } else {
      return;
    }
  };

  const handleDragEnd = (e) => {
    const isInLimit = checkDraginLimit(
      e?.clientX,
      e?.clientY,
      `${keyId}-attr-options`
    );
    if (isInLimit) {
      handleSwap();
    }
  };

  const handleSaveAttrBtn = () => {
    // if (filterOptArray(currentInputs).length) {
    const cloneInps = [...currentInputs];
    triggerLogEvent(analytics, "sb_variant_text", { attribute_key: keyId, option_count: filterOptArray(cloneInps).length });
    handleSave &&
      handleSave(keyId, mapTextOptArray(filterOptArray(cloneInps)));
    // } else {
    //   setShowErr(true);
    //   toast.error("Please add the Attribute options", {
    //     className: "errorToast",
    //     toastId: "err_attr_opt",
    //   });
    // }
  };
  return (
    <div className='mt-1'>
      <LineText>Attribute options</LineText>
      <div id={`${keyId}-attr-options`}>
        {currentInputs.map((inpVal, ind) => (
          <VariantInput
            key={ind}
            value={inpVal.value}
            handleChange={(action, val) => {
              if (val.length && val.trim() === '') return;
              setShowErr(false);
              handleAttrOptionChange(action, val, ind);
            }}
            placeholder={VariantTextPlaceholders[keyId]}
            showDelete={
              currentInputs.length > 1 && ind + 1 !== currentInputs.length
            }
            draggable={!Boolean(currentInputs.length - 1 === ind)}
            onDragStart={(e) => {
              dragStartRef.current = ind;
            }}
            onDragOver={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            onDragEnter={(e) => {
              dragOverRef.current = ind;
            }}
            onDragEnd={handleDragEnd}
            inputClassName={"variant_attr_input"}
            showError={showErr}
            disabled={isFromEditFlow && inpVal?.id}
          />
        ))}
      </div>
      <div
        className='d-flex my-4 user-select-none'
        style={{ columnGap: "1rem" }}
      >
        <UBButton
          id="variant_text_discard_btn"
          title='Discard'
          className='ub_ButtonMain discardBtn'
          titleStyle={{ color: "var(--mainColor)" }}
          onClick={setShowDiscard.bind(this, true)}
        />
        <UBButton
          id="variant_text_save_btn"
          title='Save'
          className='ub_ButtonMain saveAttrBtn ubSecondaryButton'
          onClick={handleSaveAttrBtn}
        />
      </div>
 
       <ConfirmationModal
        id="discard_modal_variant_color"
        open={showDiscard}
        onClose={handleCancel}
        onConfirm={handleSaveDiscard}
        message={"You have unsaved changes"}
        title={"Are you sure you want to leave this screen and discard your changes?"}
        cancelText={"Cancel"}
        confirmButtonClassName="ubPrimaryButton"
        confirmText='YES'
      />
    </div>
  );
};

export default VariantTextComponent;
